import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, Observable, retry } from 'rxjs';
import { Constants } from '../constant';
import { Common } from '../../shared/common';

@Injectable()
export class HostelDashboardService {

  constructor(private http: HttpClient) {}
  private api = Constants.getApiEndpoint();

  getSummary(stayIn: string = 'MAIN'): Observable<any> {
    return this.http.get<any>(`${this.api}/hostel/dashboard/summary`,
      Common.campusHeader(stayIn)).pipe(retry(1), catchError(Common.handleError));
  }

  getOccupancy(stayIn: string = 'MAIN'): Observable<any> {
    return this.http.get<any>(`${this.api}/hostel/dashboard/occupancy`,
      Common.campusHeader(stayIn)).pipe(retry(1), catchError(Common.handleError));
  }

  getCurrentResidents(stayIn: string = 'MAIN', page = 0, size = 20, search: string = ''): Observable<any> {
    let url = `${this.api}/hostel/dashboard/residents?page=${page}&size=${size}`;
    if (search && search.trim()) url += `&search=${encodeURIComponent(search.trim())}`;
    return this.http.get<any>(url, Common.campusHeader(stayIn)).pipe(retry(1), catchError(Common.handleError));
  }

  getCompleteOccupancyExport(stayIn: string = 'MAIN'): Observable<any> {
    return this.http.get<any>(`${this.api}/hostel/dashboard/export-occupancy`,
      Common.campusHeader(stayIn)).pipe(retry(1), catchError(Common.handleError));
  }

  getVacatedList(stayIn: string = 'MAIN', hostelId = '',
                 from = '', to = '', page = 0, size = 20, search: string = ''): Observable<any> {
    let url = `${this.api}/hostel/dashboard/vacated?page=${page}&size=${size}`;
    if (hostelId) url += `&hostelId=${hostelId}`;
    if (from)     url += `&from=${from}`;
    if (to)       url += `&to=${to}`;
    if (search && search.trim()) url += `&search=${encodeURIComponent(search.trim())}`;
    return this.http.get<any>(url, Common.campusHeader(stayIn))
      .pipe(retry(1), catchError(Common.handleError));
  }

  getCombinedExport(stayIn: string = 'MAIN', hostelId = '',
                    from = '', to = '', search: string = ''): Observable<any> {
    let url = `${this.api}/hostel/dashboard/export-combined`;
    const params: string[] = [];
    if (hostelId) params.push(`hostelId=${encodeURIComponent(hostelId)}`);
    if (from)     params.push(`from=${encodeURIComponent(from)}`);
    if (to)       params.push(`to=${encodeURIComponent(to)}`);
    if (search && search.trim()) params.push(`search=${encodeURIComponent(search.trim())}`);
    if (params.length > 0) {
      url += '?' + params.join('&');
    }
    return this.http.get<any>(url, Common.campusHeader(stayIn))
      .pipe(retry(1), catchError(Common.handleError));
  }

  getStudentHistory(studentId: string): Observable<any> {
    return this.http.get<any>(`${this.api}/hostel/dashboard/student-history/${studentId}`)
      .pipe(retry(1), catchError(Common.handleError));
  }

  getOverlapStays(stayIn: string = 'MAIN', search: string = ''): Observable<any> {
    let url = `${this.api}/hostel/dashboard/overlaps`;
    if (search && search.trim()) url += `?search=${encodeURIComponent(search.trim())}`;
    return this.http.get<any>(url, Common.campusHeader(stayIn))
      .pipe(retry(1), catchError(Common.handleError));
  }

  updateAllocationRemarks(id: string, remarks: string): Observable<any> {
    return this.http.put<any>(`${this.api}/hostel/dashboard/allocation/${id}/remarks`, { remarks })
      .pipe(catchError(Common.handleError));
  }

  updateHistoryRemarks(id: string, joiningRemarks?: string, vacatingRemarks?: string): Observable<any> {
    const payload: any = {};
    if (joiningRemarks !== undefined) payload.joiningRemarks = joiningRemarks;
    if (vacatingRemarks !== undefined) payload.vacatingRemarks = vacatingRemarks;
    return this.http.put<any>(`${this.api}/hostel/dashboard/history/${id}/remarks`, payload)
      .pipe(catchError(Common.handleError));
  }
}
